import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

const PayeeSameField = ({ name, validate, disabled }) => (
  <div className="form-group form-row">
    <div className="col-auto">
      <label htmlFor="fieldPayeeSame" className="label">
        Billing address same as contact
      </label>
    </div>
    <div className="col-auto my-auto">
      <div className="custom-control custom-radio custom-control-inline">
        <Field
          name={name}
          value="yes"
          id={`${name}Yes`}
          validate={validate}
          component="input"
          type="radio"
          className="custom-control-input"
          disabled={disabled}
        />
        <label className="custom-control-label label" htmlFor={`${name}Yes`}>
          Yes
        </label>
      </div>
    </div>
    <div className="col-auto my-auto">
      <div className="custom-control custom-radio custom-control-inline">
        <Field
          name={name}
          value="no"
          id={`${name}No`}
          validate={validate}
          component="input"
          type="radio"
          className="custom-control-input"
          disabled={disabled}
        />
        <label className="custom-control-label label" htmlFor={`${name}No`}>
          No
        </label>
      </div>
    </div>
  </div>
);
PayeeSameField.propTypes = {
  name: PropTypes.string.isRequired,
  validate: PropTypes.arrayOf(PropTypes.func).isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default PayeeSameField;
